import React, { Component } from 'react'
import ContactForm from './ContactForm'
import { Container } from 'react-bootstrap'

import '../../../../assets/sass/pages/landing/contact/contact.scss'

export default class Contact extends Component {
    render() {
        return (
            <div className="contact-page">
                <div className="info-container">
                    <h1 className="title">How we can help you?</h1>
                    <p className="text">Please fill in a few details below, to allows us to help you.</p>
                </div>
                <Container>
                    <ContactForm />
                </Container>
            </div>
        )
    }
}
